<script>
import EffContractAutoCalculateDetailTable from "../app/components/OrderPage/EffContractAutoCalculateDetailTable.vue";
import {NULL} from "sass";

export default {
  name: "EffectiveContractAutoCalculationDetailDialog",
  components: {EffContractAutoCalculateDetailTable},

  props: {
    dialog: {
      type: Boolean,
      required: true,
    },

    personEffContractId: {
      type: [String, Number],
    },

    personId: {
      type: [String, Number],
    },
  },

  methods: {
    close() {
      this.$emit('close')
    }
  }
}
</script>

<template>
  <v-dialog
    :value="dialog"
    @input="close"
    width="60vw"
    transition="slide-x-reverse-transition"
    content-class="rounded-xl v-dialog-right"
  >
    <v-card height="100%">
      <v-toolbar flat>
        <v-toolbar-title>Детализация расчета</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="close">
          <v-icon>fa-times</v-icon>
        </v-btn>
      </v-toolbar>
      <v-divider/>
      <eff-contract-auto-calculate-detail-table
        :person-eff-contract-id="personEffContractId"
        :person-id="personId"
      />
    </v-card>
  </v-dialog>
</template>

<style scoped>
>>> .v-dialog-right {
  position: absolute;
  border-radius: 0;
  margin: 0;
  padding: 0;
  height: 98vh;
  min-height: 98vh;
  overflow-y: auto;
  top: auto;
  right: 20px;
}
</style>